import { render, staticRenderFns } from "./TimeDifference.vue?vue&type=template&id=556f86ae&scoped=true&"
import script from "./TimeDifference.vue?vue&type=script&lang=js&"
export * from "./TimeDifference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f86ae",
  null
  
)

export default component.exports